export default "__VITE_ASSET__AXY59OPm__"